<template>
  <hm-content title="">
    <div class="table-panel flex flex-end">
      <div class="flex-1 text-right">
        <el-input
          clearable
          style="width: 200px"
          v-model.trim="searchCondition.gameName"
          placeholder="请输入活动名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-input
          clearable
          style="width: 200px"
          v-model.trim="searchCondition.keyWords"
          placeholder="请输入团订单号/团长/商品"
          size="small"
          class="ipt mr10"
        ></el-input>

        <el-select
          v-model="searchCondition.teamState"
          placeholder="请选择成团状态"
          size="small"
          clearable
          class="mr10"
        >
          <el-option label="待成团" value="0"></el-option>
          <el-option label="拼团失败" value="9"></el-option>
          <el-option label="已成团" value="1"></el-option>
        </el-select>
        <el-select
          clearable
          v-model="searchCondition.gameType"
          placeholder="请选择拼团类型"
          size="small"
          class="mr10"
        >
          <el-option label="特价团" value="bargains_team"></el-option>
          <el-option label="抽奖团" value="lottery_team"></el-option>
          <el-option label="团长免单团" value="leader_free_team"></el-option>
        </el-select>

        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button type="info" size="small" @click="searchCondition = {}"
          >重置</el-button
        >
        <el-button
          type="success"
          size="small"
          @click="output('queryAllList', '拼团订单明细')"
          :loading="isOutputing"
          >导出明细</el-button
        >
      </div>
    </div>
    <el-table
      :data="teamOrderList.records"
      style="width: 100%"
      stripe
      border
      @selection-change="getChecked"
      size="small"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="序号"
        width="50"
        :index="index => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="团订单号"
        prop="teamSn"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="活动名称"
        prop="gameName"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="成团人数或件数"
        prop="openteamNumber"
      >
        <template slot-scope="scope">
          {{ scope.row.openteamNumber }}
          <span v-if="scope.row.groupTeamType==='numberTeam'">(件)</span>
          <span v-else>(人)</span>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="拼团类型"
        prop="gameType"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.gameType === 'bargains_team'">特价团
            <span v-if="scope.row.groupTeamType==='numberTeam'">(数量团)</span>
            <span v-if="scope.row.groupTeamType==='personNumTeam'">(人数团)</span>
          </div>
          <div v-if="scope.row.gameType === 'lottery_team'">抽奖团</div>
          <div v-if="scope.row.gameType === 'leader_free_team'">团长免单团</div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="成团状态"
        prop="teamState"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.teamState === '0'" class="danger">待成团</span>
          <span v-if="scope.row.teamState === '1'" class="blue">已成团</span>
          <span v-if="scope.row.teamState === '9'" class="danger"
            >拼团失败</span
          >
        </template>
      </el-table-column>

      <el-table-column
        header-align="center"
        align="center"
        prop="wxshopSpuName"
        label="商品名称"
      ></el-table-column>

      <el-table-column
        header-align="center"
        align="center"
        prop="retailPrice"
        label="商品原价"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.retailPrice">¥{{ scope.row.retailPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="memberMobile"
        label="团长手机"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="joinCount"
        label="已参团"
      >
        <template slot-scope="scope">
          {{ scope.row.joinCount }}
          <span v-if="scope.row.groupTeamType==='numberTeam'">(件)</span>
          <span v-else>(人)</span>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="lackCount"
        label="还需参团"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.lackCount>0">{{ scope.row.lackCount }}</span>
          <span v-else>0</span>
          <span v-if="scope.row.groupTeamType==='numberTeam'">(件)</span>
          <span v-else>(人)</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" header-align="center" align="center">
        <template slot-scope="scope">
          <div class="flex flex-center">
            <el-tooltip class="item" content="查看" placement="top">
              <button class="pointer mr10 no-bg" @click="toDetails(scope.row)">
                <span class="hmicon icon-chakan blue"></span>
              </button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="teamOrderList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="80%"
    >
      <div slot="title">
        <span class="mr10">会员限制</span>
      </div>
      <div class="content">
        <ul class="info-list">
          <li class="mb20">
            <div class="title">拼团信息</div>
            <div class="mb20">
              <el-table
                stripe
                border
                :data="[detailsTeamOrder.orderInfo]"
                size="small"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  label="团订单号"
                  prop="teamSn"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="成团人数或件数"
                  prop="openteamNumber"
                >
                <template slot-scope="scope">
                  {{ scope.row.openteamNumber }}
                  <span v-if="scope.row.groupTeamType==='numberTeam'">(件)</span>
                  <span v-else>(人)</span>
                </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="拼团类型"
                  prop="gameType"
                >
                  <template slot-scope="scope">
                    <div v-if="scope.row.gameType === 'bargains_team'"
                      >特价团
                      <span v-if="scope.row.groupTeamType==='numberTeam'">(数量团)</span>
                      <span v-if="scope.row.groupTeamType==='personNumTeam'">(人数团)</span>
                      </div
                    >
                    <div v-if="scope.row.gameType === 'lottery_team'"
                      >抽奖团</div
                    >
                    <div v-if="scope.row.gameType === 'leader_free_team'"
                      >团长免单团</div
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="成团状态"
                  prop="teamState"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.teamState === '0'" class="danger"
                      >待成团</span
                    >
                    <span v-if="scope.row.teamState === '1'" class="blue"
                      >已成团</span
                    >
                  </template>
                </el-table-column>

                <el-table-column
                  header-align="center"
                  align="center"
                  prop="joinCount"
                  label="已成团"
                >
                  <template slot-scope="scope">
                    {{ scope.row.joinCount }}
                    <span v-if="scope.row.groupTeamType==='numberTeam'">(件)</span>
                    <span v-else>(人)</span>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="lackCount"
                  label="还差成团"
                >
                <template slot-scope="scope">
                  <span v-if="scope.row.lackCount>0">{{ scope.row.lackCount }}</span>
                  <span v-else>0</span>
                  <span v-if="scope.row.groupTeamType==='numberTeam'">(件)</span>
                  <span v-else>(人)</span>
                </template>
                </el-table-column>
              </el-table>
            </div>
          </li>
          <li class="mb20">
            <div class="title">商品信息</div>
            <el-table
              stripe
              border
              :data="[detailsTeamOrder.goodsInfo]"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsSn"
                label="商品货号"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="wxshopSpuName"
                label="商品名称"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="retailPrice"
                label="零售价"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.retailPrice"
                    >¥{{ scope.row.retailPrice }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="totalStockSum"
                label="活动库存"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="eachPurchaseLimit"
                label="单人限购"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="leaderProfitPrice"
                label="团长特惠价"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.leaderProfitPrice"
                    >¥{{ scope.row.leaderProfitPrice }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="jointeamProfitPrice"
                label="参团价"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.jointeamProfitPrice"
                    >¥{{ scope.row.jointeamProfitPrice }}</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </li>
          <li class="mb20">
            <div class="title">团员信息</div>
            <el-table
              stripe
              border
              :data="detailsTeamOrder.orderMemberList"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                prop="teamSn"
                label="团订单号"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiptSn"
                label="个人订单号"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="createTime"
                label="下单时间"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="teamPosition"
                label="团内身份"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.teamPosition === 'leader'">团长</span>
                  <span v-if="scope.row.teamPosition === 'member'">团员</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="memberName"
                label="用户昵称"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="memberMobile"
                label="用户手机"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsNum"
                label="购买商品"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiverName"
                label="收货人"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="deliveryProvince"
                label="收货地址"
              >
                <template slot-scope="scope">
                  <p>
                    {{ scope.row.deliveryProvince }}{{ scope.row.deliveryCity
                    }}{{ scope.row.deliveryDistrict
                    }}{{ scope.row.deliveryAddress }}
                  </p>
                </template>
              </el-table-column>
            </el-table>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="dialogVisible = false" size="small" type="primary"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import { setCookie, getCookie } from "@/utils/utils";
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      isOutputing: false,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      searchCondition: {},
      exportTeamSn: []
    };
  },
  computed: mapGetters(["teamOrderList", "detailsTeamOrder"]),
  watch: {},
  created() {},
  mounted() {
    this.getParamsCookie();
    this.queryList();
  },
  methods: {
    getChecked(selection) {
      this.exportTeamSn = selection.map(v => v.teamSn);
    },
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.setParamsCookie();
      Object.assign(params, searchCondition);

      return this.$store.dispatch("teamOrderList", params);
    },
    queryAllList() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.exportTeamSn = this.exportTeamSn;
      return this.$store.dispatch("queryGameTeamOrderDetails", searchCondition);
    },
    // 导出excel
    output(funcName, title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const func = this[funcName];
        func()
          .then(res => {
            const list = res.result;
            // list.forEach(v => {
            //   if (v.deliveryType === "mdzt") {
            //     v.deliveryType = "门店自提";
            //   } else if (v.deliveryType === "kdfh") {
            //     v.deliveryType = "快递发货";
            //   } else if (v.deliveryType === "tcps") {
            //     v.deliveryType = "同城配送";
            //   }
            // });
            // const tHeader = this.$refs.table.columns
            //   .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
            //   .filter(o => o);
            const tHeader = [
              "活动名称",
              "团订单号",
              "成团人数",
              "拼团类型",
              "成团状态",
              "商品货号",
              "商品条码",
              "商品名称",
              "商品原价",
              "个人订单号",
              "参与时间",
              "团内身份",
              "用户昵称",
              "用户手机",
              "商品数量",
              "实付金额",
              "收货人",
              "收货地址",
              "支付状态"
            ];
            const filterVal = [
              "gameName",
              "teamSn",
              "openteamNumber",
              "gameType",
              "teamState",
              "goodsSn",
              "specBarcode",
              "goodsName",
              "retailPrice",
              "receiptSn",
              "createTime",
              "teamPosition",
              "nickName",
              "memberMobile",
              "goodsNum",
              "payAmount",
              "receiverName",
              "address",
              "payState"
            ];
            // if (list.length > 0) {
            //   filterVal = this.$refs.table.$children
            //     .map(o => o._props.prop)
            //     .filter(o => o);
            // }
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    setParamsCookie() {
      setCookie({
        key: "teamOrderListParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "teamOrderListParams", type: "session" });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    toDetails(row) {
      let params = {
        teamSn: row.teamSn
      };

      this.dialogVisible = true;
      this.$store.dispatch("detailsTeamOrder", params);
    }
  }
};
</script>
<style lang="scss" scoped>
.info-list {
  padding: 0 20px;
}
.info-list,
.logistics-list {
  .title {
    margin-bottom: 8px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
</style>
